import './streamResponseRecorderGlobals';
import { type StreamMessage } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { installStreamResponseOutputGetter } from './installStreamResponseOutputGetter';

// Install `window.top.__rovoStreamResponseOutput__` at module load. This module is
// pulled into the runtime bundle because `processStream` imports the used
// `recordStreamMessage` binding below, so this top-level call is retained (the package
// is marked `sideEffects: ["*.compiled.css"]`, so a bare `import './x'` for effect would
// be tree-shaken away).
installStreamResponseOutputGetter();

/**
 * Records a single stream message by JSON-stringifying it and appending
 * to the `window.top.__rovoStreamResponseMessages__` array.
 */
export const recordStreamMessage = (message: StreamMessage): void => {
	try {
		if (window.top) {
			if (!window.top.__rovoStreamResponseMessages__) {
				window.top.__rovoStreamResponseMessages__ = [];
			}
			const serialised = JSON.stringify(message);
			window.top.__rovoStreamResponseMessages__.push(serialised);
		}
	} catch {
		// Ignore cross-origin frame access errors
	}
};
